import ChevronLightBgIcon from "../../assets/icons/chevron-light-background.svg";
import { useNavigate } from "react-router-dom";
import "./AppHeader.less";

interface AppHeaderProps {
  title: string;
  backButtonDestination?: string | -1;
  showBackButton?: boolean;
  fontSize?: string;
  onBackClick?: () => void;
  rightIconSrc?: string;
  rightIconAlt?: string;
  onRightIconClick?: () => void;
}

const AppHeader = ({
  title,
  backButtonDestination = "/employee",
  showBackButton = true,
  fontSize = "32",
  onBackClick,
  rightIconSrc,
  rightIconAlt = "Action",
  onRightIconClick,
}: AppHeaderProps) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else if (backButtonDestination === -1) {
      navigate(-1);
    } else {
      navigate(backButtonDestination);
    }
  };

  return (
    <div className="app-header">
      {showBackButton && (
        <img
          src={ChevronLightBgIcon}
          className="header-back-button"
          alt="Back"
          onClick={handleBackClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && handleBackClick()}
        />
      )}
      <h1 className="header-title" style={{ fontSize: `${fontSize}px` }}>
        {title}
      </h1>
      {rightIconSrc && (
        <img
          src={rightIconSrc}
          className="header-right-icon"
          alt={rightIconAlt}
          onClick={onRightIconClick}
          role={onRightIconClick ? "button" : undefined}
          tabIndex={onRightIconClick ? 0 : -1}
          onKeyDown={(e) => onRightIconClick && e.key === "Enter" && onRightIconClick()}
        />
      )}
    </div>
  );
};

export default AppHeader;
